import React, { useState } from 'react';
import { Row, Col, size } from '@everlywell/leaves';
import { generateKey } from 'utils/helpers';
import { animated as A, useSpring, config } from 'react-spring';

import { useScrolledIntoViewOnce } from 'utils/hooks';

import SectionTitle from '../SectionTitle';
import Container from '../Container';

import * as S from './styles';

type ContentWithImage = {
  heading: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
};

export interface OutreachSectionProps {
  title: string;
  headline: string;
  subheadline: string;
  listOfContent: ContentWithImage[];
}

export const OutreachSection: React.FC<OutreachSectionProps> = ({
  title,
  headline,
  listOfContent,
  subheadline,
}) => {
  const [topSectionInView, setTopSectionInView] = useState(false);
  const [bottomSectionInView, setBottomSectionInView] = useState(false);

  const topSectionEl = useScrolledIntoViewOnce(() => {
    setTopSectionInView(true);
  });

  const bottomSectionEl = useScrolledIntoViewOnce(() => {
    setBottomSectionInView(true);
  });

  // triggered from scrolling into view
  const topSectionTransition = useSpring({
    opacity: topSectionInView ? 1 : 0,
    transform: topSectionInView ? 'translateY(0)' : `translateY(${size.xl3}px)`,
    config: config.slow,
  });

  // triggered from scrolling into view
  const bottomSectionTransition = useSpring({
    opacity: bottomSectionInView ? 1 : 0,
    transform: bottomSectionInView
      ? 'translateY(0)'
      : `translateY(${size.xl3}px)`,
    config: config.slow,
  });

  return (
    <Container>
      <div ref={topSectionEl}>
        {/* @ts-ignore */}
        <A.div style={topSectionTransition}>
          <Row center="xs">
            <Col xs={12} lg={10}>
              <SectionTitle text={title} />
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={12} lg={10}>
              <S.SectionHeadline>{headline}</S.SectionHeadline>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={12} lg={6}>
              <S.SectionSubheadline>{subheadline}</S.SectionSubheadline>
            </Col>
          </Row>
        </A.div>
      </div>
      <div ref={bottomSectionEl}>
        {/* @ts-ignore */}
        <A.div style={bottomSectionTransition}>
          <Row center="xs" around="lg">
            <Col xs={12}>
              <S.InfoBlockContainer>
                {listOfContent.length
                  ? listOfContent.map(content => (
                      <S.InfoBlockWrapper>
                        <S.InfoBlock
                          title={content.heading}
                          image={content.imageSrc}
                          imageAlt={content.imageAlt}
                          content={content.description}
                          size="small"
                          key={generateKey()}
                        />
                      </S.InfoBlockWrapper>
                    ))
                  : null}
              </S.InfoBlockContainer>
            </Col>
          </Row>
        </A.div>
      </div>
    </Container>
  );
};

export default OutreachSection;
